module.exports = __webpack_public_path__ + "static/img/bg-1.235339a2.png";